<!--
    Summary:
        首张banner图
    ChangeLog:
        Labbor on 2020/2/21 added
-->
<template>
  <div class="v-banner">
    <div class="banner-wrapper">
      <slot></slot>
    </div>
    <div class="bottom">
      <div class="title">
        <slot name="title"></slot>
      </div>
      <div class="op">
        <slot name="action"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "sub-banner",
    data() {
      return {}
    },
    methods: {},
  }
</script>

<style scoped lang="scss">
  .v-banner {

    width: 100%;
    position: relative;
    text-align: left;

    .banner-wrapper{
      img {
        width: 100%;
        height: 25vw;
      }
    }


    .bottom {
      height: 7vw;
      display: flex;
      align-items: center;
      background: url('../assets/images/home/p2-projects-h-bg.png');
      background-size: 100% 100%;
      padding-left: 20%;

      .title {
        width: 38vw;
        height: 4.5vw;
        line-height: 4.5vw;
        font-size: 2.5vw;
        color: #ffffff;
        text-align: left;
      }

      .op {
        width: 19.5vw;
        margin-left: 4%;
        text-align: center;
        &>* {
          text-decoration: underline;
          font-size: 1.25vw;
          color: #1bb89d;
          cursor: pointer;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/sub-banner.vue